// extracted by mini-css-extract-plugin
export default {"loadingWrap":"index_loadingWrap__l3Gc6","spin":"index_spin__-f9Ze"};